import React from "react";
import styled from "styled-components";

const Vessel = styled.div`
  display: grid;
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "auto"};
  min-width: ${(props) => props.minWidth || "325px"};
  margin: ${(props) => props.margin || 0};
  grid-gap: ${(props) => props.gridGap || 0};
  padding: ${props => props.padding || '0'};

  ${(props) =>
    (props.mobile || props.wrapWidth) &&
    `@media only screen and (max-width: ${props.wrapWidth || 800}px) {
        grid-template-columns: repeat(auto-fill, 100%)!important;
      }`}
`;

const Grid = (props) => {
  const {
    id,
    onClick,
    children,
    layout,
    column,
    width,
    height,
    mobile,

    minWidth,
    style,
    margin,
    wrapWidth,
  } = props;
  let formattedLayout = "";
  if (Array.isArray(layout))
    formattedLayout = layout.reduce((acc, curr) => (acc += ` ${curr}%`), "");
  else if (typeof layout === "string") formattedLayout = layout;

  let gridTemplateColumns = formattedLayout;
  let gridTemplateRows = formattedLayout;

  const layoutStyle = column ? { gridTemplateRows } : { gridTemplateColumns };

  return (
    <Vessel

      id={id}
      onClick={onClick ? onClick : null}
      {...props}
      style={{
        ...layoutStyle,
        ...style,
      }}
    >
      {children}
    </Vessel>
  );
};

export default Grid;
